import Buybox from '../vue/buybox/index';
import StickyBar from '../components/sticky-bar';
import ProductSlider from '../vue/product-slider/index';

Buybox();
StickyBar();
ProductSlider();